import { Navigate, Outlet, useLocation } from "react-router-dom";
import { usePrivateRoute } from "../hooks/usePrivateRoute";

const Private = () => {
  const location = useLocation();
  const { isAuthenticated } = usePrivateRoute(location);

  return isAuthenticated ? <Outlet /> : <Navigate to="/" />;
};

export default Private;
